import { useGetTjenesteTeksterQuery } from '@helsenorge/framework-utils/cms-tjeneste-tekster';
import { selectCurrentLanguage } from '@helsenorge/framework-utils/language';
import useCustomHjelpetekstById from './useCustomHjelpetekstById';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { HNeventOpenHjelpeskuff } from '../../events';
import { openHjelpeskuff as openHjelpeskuffAction } from '../hjelpeskuff';
/**
 * Hent spesifikk hjelpetekst for en tjeneste
 * @param tjenesteNavn Navn på tjenesten
 * @param hjelpetekstId Id til hjelpeteksten
 * @param useCustomEvent Dersom hjelpekomponenten brukes i microweb, må hjelpeskuffen åpnes med et custom event
 */
const useHjelpetekstById = (tjenesteNavn, hjelpetekstId, useCustomEvent = false) => {
    const dispatch = useAppDispatch();
    const language = useAppSelector(state => selectCurrentLanguage(state.language));
    const { data, isLoading, isError } = useGetTjenesteTeksterQuery({
        navn: tjenesteNavn,
        languageCode: language,
    });
    const customHjelpetekst = useCustomHjelpetekstById(tjenesteNavn, hjelpetekstId, useCustomEvent);
    if (customHjelpetekst.hjelpetekst) {
        return {
            hjelpetekst: customHjelpetekst.hjelpetekst,
            isLoading: false,
            isError: false,
            openHjelpeskuff: customHjelpetekst.openHjelpeskuff,
        };
    }
    let hjelpetekst;
    if (Array.isArray(hjelpetekstId)) {
        hjelpetekst = data?.hjelpetekster?.hjelpetekster.find(tekst => hjelpetekstId.includes(tekst.id));
    }
    else {
        hjelpetekst = data?.hjelpetekster?.hjelpetekster?.find(tekst => tekst.id === hjelpetekstId);
    }
    const openHjelpeskuff = () => {
        if (!hjelpetekst?.hjelpeskuffTittel || !hjelpetekst?.hjelpeskuffTekst) {
            return;
        }
        if (useCustomEvent) {
            HNeventOpenHjelpeskuff({ tjenesteNavn, hjelpetekstId, language });
        }
        else {
            dispatch(openHjelpeskuffAction({ hjelpeskuffTittel: hjelpetekst.hjelpeskuffTittel, hjelpeskuffTekst: hjelpetekst.hjelpeskuffTekst }));
        }
    };
    return {
        hjelpetekst,
        isLoading,
        isError,
        openHjelpeskuff,
    };
};
export default useHjelpetekstById;
